(function() {
  'use strict';

  if (!document.querySelector('.quick-variant-selector')) return;

  class QuickVariantSelector {
    constructor(element) {
      this.container = element;
      this.productId = element.dataset.productId;
      this.selectedVariant = null;
      
      this.initDesktop();
      this.initMobile();
    }

    initDesktop() {
      const overlay = this.container.querySelector('.qv-card-overlay');
      if (!overlay) return;

      const forms = overlay.querySelectorAll('.qv-variant-form');
      
      // Pre-select first available variant
      const firstAvailable = overlay.querySelector('[data-first-available]');
      if (firstAvailable) {
        firstAvailable.classList.add('qv-variant-option--selected');
        this.selectedVariant = firstAvailable.dataset.variantId;
      }

      // Intercept form submits - app should detect form[action*='/cart/add']:has(button)
      // Use event delegation on document with capture to let app intercept first
      forms.forEach(form => {
        // Store form reference for cleanup
        form._qvFormHandler = (e) => {
          // Only handle if this is our form
          if (e.target !== form) return;
          
          const button = form.querySelector('button[type="submit"]');
          if (button && !button.disabled) {
            // Update selected state
            const allOptions = overlay.querySelectorAll('.qv-variant-option');
            allOptions.forEach(opt => opt.classList.remove('qv-variant-option--selected'));
            button.classList.add('qv-variant-option--selected');
            this.selectedVariant = button.dataset.variantId;
            
            // Check if app already prevented default
            // If not, handle via AJAX (app should have intercepted by now)
            if (!e.defaultPrevented) {
              e.preventDefault();
              this.addToCartViaForm(form);
            }
          }
        };
        
        // Add listener on form (bubble phase) - app should intercept in capture phase
        form.addEventListener('submit', form._qvFormHandler);
      });
    }

    initMobile() {
      const trigger = this.container.querySelector('.qv-mobile-trigger');
      
      if (trigger) {
        trigger.addEventListener('click', () => {
          this.openMobileModal();
        });
      }
    }

    openMobileModal() {
      // Get or create global modal
      let modal = document.querySelector('.qv-global-mobile-modal');
      
      if (!modal) {
        modal = document.createElement('div');
        modal.className = 'qv-global-mobile-modal';
        modal.innerHTML = `
          <div class="qv-mobile-modal-content">
            <div class="qv-mobile-loading">
              <svg class="qv-loading-spinner" aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66">
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>

            <div class="qv-mobile-header">
              <button type="button" class="qv-mobile-close" aria-label="Close">✕</button>
              <div class="qv-mobile-product">
                <img class="qv-mobile-product-image" alt="" width="80" height="80" loading="lazy">
                <div class="qv-mobile-product-info">
                  <h3 class="qv-mobile-product-title"></h3>
                  <div class="qv-mobile-product-price"></div>
                </div>
              </div>
            </div>

            <div class="qv-mobile-variants">
              <h4 class="qv-mobile-variants-title">Seleccionar talla</h4>
              <div class="qv-mobile-variants-grid"></div>
            </div>

            <div class="qv-mobile-actions">
              <button type="button" class="qv-mobile-add-cart button button--full-width button--secondary">
                Add to cart
                <div class="loading-overlay__spinner hidden">
                  <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </button>
            </div>
          </div>
        `;
        document.body.appendChild(modal);
      }

      // Get original modal for content
      const originalModal = this.container.querySelector('.qv-mobile-modal');
      if (!originalModal) return;

      // Clone and update content
      const originalContent = originalModal.querySelector('.qv-mobile-modal-content');
      const modalContent = modal.querySelector('.qv-mobile-modal-content');
      modalContent.innerHTML = originalContent.innerHTML;

      // Setup event listeners for this instance
      this.setupModalListeners(modal);

      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    setupModalListeners(modal) {
      const closeBtn = modal.querySelector('.qv-mobile-close');
      const variants = modal.querySelectorAll('.qv-mobile-variant-option:not(.qv-mobile-variant-option--sold-out)');
      const addBtn = modal.querySelector('.qv-mobile-add-cart');

      // Pre-select first available variant
      const firstAvailable = modal.querySelector('[data-first-available]');
      if (firstAvailable) {
        firstAvailable.classList.add('qv-mobile-variant-option--selected');
        this.selectedVariant = firstAvailable.dataset.variantId;
      }

      // Remove old listeners by cloning
      const newCloseBtn = closeBtn.cloneNode(true);
      closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
      newCloseBtn.addEventListener('click', () => {
        this.closeMobileModal();
      });

      // Close on backdrop click
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          this.closeMobileModal();
        }
      });

      // Variant selection - apenas seleciona e atualiza o input
      variants.forEach(variant => {
        variant.addEventListener('click', () => {
          if (variant.disabled || variant.classList.contains('qv-mobile-variant-option--sold-out')) {
            return;
          }
          
          variants.forEach(v => v.classList.remove('qv-mobile-variant-option--selected'));
          variant.classList.add('qv-mobile-variant-option--selected');
          this.selectedVariant = variant.dataset.variantId;
          
          if (variantInput) {
            variantInput.value = variant.dataset.variantId;
          }
        });
      });

      // Add to cart - update form input quando variante é selecionada
      const form = modal.querySelector('.qv-mobile-cart-form');
      const variantInput = form?.querySelector('.qv-mobile-variant-input');
      
      if (form && variantInput) {
        // Handle form submit (permitir que o app intercepte). Só bloqueia se não houver variante.
        form.addEventListener('submit', (e) => {
          if (!variantInput.value || variantInput.value === '0') {
            e.preventDefault();
            form.classList.add('qv-mobile-form--error');
            return;
          }
          form.classList.remove('qv-mobile-form--error');
          // Permite o submit normal para que o app abra o carrinho.
          // Fecha o modal logo depois para evitar sobreposição.
          setTimeout(() => {
            this.closeMobileModal();
          }, 400);
        });
      }
    }

    closeMobileModal() {
      const modal = document.querySelector('.qv-global-mobile-modal');
      if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    showLoading(isMobile = false) {
      if (isMobile) {
        const modal = document.querySelector('.qv-global-mobile-modal');
        const mobileLoading = modal?.querySelector('.qv-mobile-loading');
        const mobileAddBtn = modal?.querySelector('.qv-mobile-add-cart');
        if (mobileLoading) mobileLoading.classList.add('active');
        if (mobileAddBtn) {
          mobileAddBtn.setAttribute('aria-disabled', 'true');
          mobileAddBtn.classList.add('loading');
          mobileAddBtn.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
        }
      } else {
        const desktopLoading = this.container.querySelector('.qv-loading-overlay');
        if (desktopLoading) desktopLoading.classList.add('active');
      }
    }

    hideLoading(isMobile = false) {
      if (isMobile) {
        const modal = document.querySelector('.qv-global-mobile-modal');
        const mobileLoading = modal?.querySelector('.qv-mobile-loading');
        const mobileAddBtn = modal?.querySelector('.qv-mobile-add-cart');
        if (mobileLoading) mobileLoading.classList.remove('active');
        if (mobileAddBtn) {
          mobileAddBtn.removeAttribute('aria-disabled');
          mobileAddBtn.classList.remove('loading');
          mobileAddBtn.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        }
      } else {
        const desktopLoading = this.container.querySelector('.qv-loading-overlay');
        if (desktopLoading) desktopLoading.classList.remove('active');
      }
    }

    async addToCartViaForm(form, isMobile = false) {
      const variantInput = form.querySelector('input[name="id"]');
      const variantId = variantInput ? variantInput.value : null;
      
      if (!variantId || variantId === '0') {
        console.error('No variant selected');
        this.hideLoading(isMobile);
        return;
      }

      this.showLoading(isMobile);

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      
      const formData = new FormData(form);

      if (cart && cart.getSectionsToRender) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      try {
        const response = await fetch(routes.cart_add_url, config);
        const data = await response.json();

        if (data.status) {
          console.error('Error adding to cart:', data.description);
          this.hideLoading(isMobile);
        } else {
          this.hideLoading(isMobile);
          
          // Remove is-empty class if cart was empty
          if (cart) {
            cart.classList.remove('is-empty');
            const drawerInner = cart.querySelector('.drawer__inner');
            if (drawerInner) {
              drawerInner.classList.remove('is-empty');
            }
          }
          
          // Close mobile modal first if on mobile
          if (isMobile) {
            this.closeMobileModal();
            // Wait a bit for modal close animation, then open drawer
            setTimeout(() => {
              if (cart) {
                cart.renderContents(data); // This automatically opens the drawer
              }
            }, 300);
          } else {
            // Desktop - open drawer immediately
            if (cart) {
              cart.renderContents(data); // This automatically opens the drawer
            }
          }
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        this.hideLoading(isMobile);
      }
    }
  }

  // Initialize all quick variant selectors
  document.addEventListener('DOMContentLoaded', () => {
    const selectors = document.querySelectorAll('.quick-variant-selector');
    selectors.forEach(selector => {
      new QuickVariantSelector(selector);
    });
  });
})();

